import { mergeStyleSets } from "@fluentui/react";
const DOT_SIZE = 12;
const CONNECTOR_HEIGHT = 2;
const CONNECTOR_MIN_WIDTH = 16;
const COLORS = {
    complete: "#107c10",
    active: "#0078d4",
    inactive: "#c8c6c4",
    blocked: "#d13438",
};
export const getStatusBubblesStyles = (activeColor, compact) => mergeStyleSets({
    root: {
        display: "flex",
        flexDirection: "column",
        alignItems: compact ? "flex-start" : "center",
        padding: compact ? 0 : "4px 0",
    },
    track: {
        display: "flex",
        alignItems: "center",
        width: "100%",
    },
    dotFilled: {
        width: DOT_SIZE,
        height: DOT_SIZE,
        borderRadius: "50%",
        backgroundColor: activeColor,
        flexShrink: 0,
        "@media (forced-colors: active)": {
            // Borders retain the filled shape when contrast themes suppress backgrounds.
            border: `${DOT_SIZE / 2}px solid CanvasText`,
            boxSizing: "border-box",
        },
    },
    dotEmpty: {
        width: DOT_SIZE,
        height: DOT_SIZE,
        borderRadius: "50%",
        backgroundColor: COLORS.inactive,
        flexShrink: 0,
        "@media (forced-colors: active)": {
            border: "1px solid CanvasText",
            boxSizing: "border-box",
        },
    },
    connectorFilled: {
        flex: 1,
        height: CONNECTOR_HEIGHT,
        minWidth: CONNECTOR_MIN_WIDTH,
        backgroundColor: activeColor,
        "@media (forced-colors: active)": {
            borderTop: `${CONNECTOR_HEIGHT}px solid CanvasText`,
            boxSizing: "border-box",
        },
    },
    connectorEmpty: {
        flex: 1,
        height: CONNECTOR_HEIGHT,
        minWidth: CONNECTOR_MIN_WIDTH,
        backgroundColor: COLORS.inactive,
        "@media (forced-colors: active)": {
            borderTop: `${CONNECTOR_HEIGHT}px dashed CanvasText`,
            boxSizing: "border-box",
        },
    },
    label: {
        fontSize: "11px",
        marginTop: 4,
        color: activeColor,
        fontWeight: 600,
    },
});
export { COLORS };
